export class GameConfig {
    public static symbolWidth: number = 100;
    public static symbolHeight: number = 112;
    public static totalSymsPerReel: number = 4;
    public static defaultGameAreaSize: number[] = [this.totalSymsPerReel, this.totalSymsPerReel, this.totalSymsPerReel, this.totalSymsPerReel, this.totalSymsPerReel];
    public static totalReels: number = this.defaultGameAreaSize.length;

    public static reelAllInStopDelay: number = 0.08;
    public static reelAllInStopDelayFastSpin: number = this.reelAllInStopDelay * 0.5;

    public static reelAllOutStopDelay: number = 0.08;
    public static reelAllOutStopDelayFastSpin: number = this.reelAllOutStopDelay * 0.5;

    public static reelAllOutDuration: number = 0.3;
    public static reelAllOutDurationFastSpin: number = this.reelAllOutDuration * 0.5;

    // symbol out delay for each row (not reel)
    public static reelSpinStartSymbolDelay: number = 0.08;

    // total time needed from 1st visible symbol to last symbol drop
    public static fillUpTotalSpinDuration: number = 0.2;
    public static fillUpTotalSpinDurationFastSpin: number = this.fillUpTotalSpinDuration * 0.5;

    // symbols fill up timing on avalanche
    public static reelFillUpStopDelay: number = 0.08;
    public static reelFillUpStopDelayFastSpin: number = this.reelFillUpStopDelay * 0.5;

    // gap between all symbols out and all symbols in
    public static reelFillUpSpinStopSymbolDelay: number = 0.04;
    public static reelFillUpSpinStopSymbolDelayFastSpin: number = this.reelFillUpSpinStopSymbolDelay * 0.5;

    // reel collapse delay
    // set to 0.001 if actual is needed, 0.04 for buffer
    public static collapseReelDelay: number = 0.001;
    public static symbolCollapseDuration: number = 0.3;
    public static symbolCollapseDurationFastSpin: number = this.symbolCollapseDuration * 0.5;


    // reel near win delay
    public static nearWinDelay: number = 0.3;

    // total time needed from 1st visible symbol to last symbol drop
    public static mainAllInTotalSpinDuration: number = 0.2;
    public static mainAllInTotalSpinDurationFastSpin: number = this.mainAllInTotalSpinDuration * 0.5;

    // gap between all symbols out and all symbols in
    public static mainReelSpinStopSymbolDelay: number = 0.04;
    public static mainReelSpinStopSymbolDelayFastSpin: number = this.mainReelSpinStopSymbolDelay * 0.5;

    // symbol blur state delay, all in
    public static mainReelAllInBlurDelay: number = 0.22; //if changed need to handle sounds for landing
    public static mainReelAllInBlurDelayFastSpin: number = this.mainReelAllInBlurDelay * 0.5;

    // symbol blur state delay, all out
    public static mainReelAllOutBlurDelay: number = 0.22; //if changed need to handle sounds for landing
    public static mainReelAllOutBlurDelayFastSpin: number = this.mainReelAllOutBlurDelay * 0.5;

    // top reel
    public static pushDelayBetweenItems: number = 0.08;
    public static pushItemDuration: number = 0.4;
    public static itemDropTime: number = 0.06;
    public static triggerDeadDuration: number = 0.3;
    public static nudgeStepDuration: number = 0.2;

    public static defaultFPS: number = 30;

    public static TOTAL_GAME_MULTIPLIER: number = 0;
    public static itemDropShakePower: number = 0.8;

    public static TOTAL_SCATTER_COUNT: number = 0;
    public static SATAN_SPIN_START_DELAY: number = 1;
    public static SATAN_SPIN_START_DELAY_IN_AUTOPLAY: number = 0.3;
    public static SATAN_SPIN_END_DELAY: number = 1;
    public static SATAN_SPIN_SYMBOL_DROP_TIME: number = 0.3;

    public static PREV_XBET_TYPE: string | undefined = undefined;

    public static MAX_WIN_START_DELAY: number = 1;

    public static MAX_PRESENTABLE_SPLITS: number = 4;

    public static MAX_WIN_MULTIPLIER: number = 61446;

    public static CAP_MACHINE_DEF_POS_Y: number = 460;

    //scatter anticipation delay
    public static scatterAnticipationDelay: number = 0.125;
    public static scatterAnticipationDelayFastSpin: number = this.scatterAnticipationDelay * 0.5;
    public static NEAR_SCATTER_WIN_DELAY: number = 0;
    public static scatterLandedInReels: boolean[] = [false, false, false, false, false];
    public static scatterPositions: number[] = [];
    public static hasAnticipation: boolean[] = [];
    public static scatterSoundsPlayed: boolean[] = [];

    //skip checks
    public static isDeadSkipped: boolean = false;

    public static isBackFromAS: boolean = false;

    // symbol bobble related stuff
    public static normalBobbleRotation: number = 0.1;
    public static nudgeBobbleRotation: number = 0.01;
    public static bobbleDuration: number = 0.15;

    public static tanksDelay: number = 15;
    public static tanksMoveDuration: number = 10;
    public static isGameIdle: boolean = false;
}

export enum TopReelFeaturesList {
    DEAD = "D",
    WILD = "W",
    XNUDGE = "XNUDGE",
    LAUNCH = "LAUNCH",
    MAGA_CAP = "MAGA_CAP",
}

export enum SideReelFeaturesList {
    XSPLIT = "XSPLIT",
    XBOMB = "XBOMB"
}

export enum SideReelMultipliersList {
    X2 = "X2",
    X3 = "X3",
    X4 = "X4",
    X5 = "X5",
    X99 = "X99"
}

export enum BlankFeature {
    BLANK = "BLANK"
}

export enum FeatureList {
    DEAD = TopReelFeaturesList.DEAD,
    WILD = TopReelFeaturesList.WILD,
    XNUDGE = TopReelFeaturesList.XNUDGE,
    LAUNCH = TopReelFeaturesList.LAUNCH,
    MAGA_CAP = TopReelFeaturesList.MAGA_CAP,
    XSPLIT = SideReelFeaturesList.XSPLIT,
    XBOMB = SideReelFeaturesList.XBOMB,
    X2 = SideReelMultipliersList.X2,
    X3 = SideReelMultipliersList.X3,
    X4 = SideReelMultipliersList.X4,
    X5 = SideReelMultipliersList.X5,
    X99 = SideReelMultipliersList.X99,
    BLANK = BlankFeature.BLANK,
}